import { Heading, Text } from '@lmc/ui-kit/src/general'
import { Trans, useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import LmcBackgroundLogo from './LmcBackgroundLogo'
import PaywallIcon from './PaywallIcon'
import useRosteringPaywall from './useRosteringPaywall'

export type SettingsPaywallProps = {
  startingText: string
  children: React.ReactElement | React.ReactElement[]
}

const SettingsPaywall = ({ startingText, children }: SettingsPaywallProps) => {
  const { t } = useTranslation()
  const { isLocked } = useRosteringPaywall()

  if (isLocked) {
    return (
      <Container>
        <LeftContainer>
          <Heading level={1}>{t('SETTINGS_PAYWALL_TITLE')}</Heading>
          <TextContainer>
            <Text weight="bold">
              {t('SETTINGS_PAYWALL_ROSTERING_ADDON_TEXT', { startingText })}
            </Text>
            <Text weight="bold">
              <Trans
                components={{
                  Link: (
                    <Link
                      to={t('SETTINGS_PAYWALL_UPGRADE_LINK')}
                      target="_blank"
                    />
                  )
                }}
              >
                SETTINGS_PAYWALL_UPGRADE_TEXT
              </Trans>
            </Text>
            <Text weight="bold">{t('SETTINGS_PAYWALL_SIGN_OFF_TEXT')}</Text>
          </TextContainer>
        </LeftContainer>
        <RightContainer>
          <PaywallIcon />
        </RightContainer>

        <LmcBackgroundLogo />
      </Container>
    )
  }

  return children
}

export default SettingsPaywall

const Container = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.color.status.popout};
  color: ${({ theme }) => theme.color.neutral.color11};
  padding: 40px 102px;
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 64px;

  a {
    &,
    &:active,
    &:focus,
    &:hover {
      color: inherit;
      text-decoration: underline;
    }
  }
`

const LeftContainer = styled.div`
  max-width: 485px;
  z-index: 1;
`

const RightContainer = styled.div`
  z-index: 1;
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 10px;
`
